import AuthPageSharedStyle from '../AuthPageSharedStyle';

const LoginPageStyle = {
    ...AuthPageSharedStyle,

    logoContainer: {
        display: 'block',
        width: '40%',
        minWidth: '200px',
        maxHeight: '70%',
        margin: '20px auto',
        marginBottom: '70px',
    },
    pseudoLink: {
        color: 'inherit',
        textDecoration: 'underline'
    }
};

export default LoginPageStyle;
